export default "__VITE_PUBLIC_ASSET__cb2b636a__"